import DefaultLayout from "@/layouts/DefaultLayout";
import Traction from "@/components/Front/VTO/Traction";
import Vision from "@/components/Front/VTO/Vision";
import eosModelLogo from "@/assets/eos-model.png";
import { FetchesData, Pageable } from "kinnect-mixins";
import {
	VCol,
	VImg,
	VRow
} from "vuetify/lib";
import { VTO } from "kinnect-models";

export default {
	name: "VisionTractionOrganizerPage",

	metaInfo: { title: "Vision/Traction Organizer" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		vto: {}
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "edit_vto" ) ) {
				return {
					icon: "add_circle",
					text: "Edit VTO",
					to: { name: "vtoEdit" }
				};
			}
		}
	},

	methods: {
		async fetchVTO() {
			this.vto = await VTO.first();
		},

		async fetch() {
			await this.fetchVTO();
		}
	},

	render() {
		return <DefaultLayout maxWidth="1200px">
			<VRow align="center">
				<VImg
					class="mx-auto"
					maxHeight={250}
					maxWidth={250}
					src={eosModelLogo}
				></VImg>

				<VCol>
					<h1 class={{
						"text-h2": this.$vuetify.breakpoint.mdAndUp,
						"text-h4": this.$vuetify.breakpoint.smAndDown,
						"text-center": true
					}}>THE VISION / TRACTION ORGANIZER</h1>
				</VCol>
			</VRow>

			{this.fetched && [
				<Vision class="mt-2" vto={this.vto}></Vision>,
				<Traction class="mt-4" vto={this.vto}></Traction>
			]}
		</DefaultLayout>;
	}
};
